<template>
  <d-row no-gutters class="page-header py-4">
    <div class="col-12 text-sm-left mb-0">
      <span class="text-uppercase page-subtitle d-block">{{ title }}</span>
      <h3 class="page-title d-inline">{{ subTitle }}</h3>
      <slot></slot>
    </div>
  </d-row>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
};
</script>
